

module.exports = __webpack_require__.stylable.create(
    "Checkbox1720959521",
    {"classes":{"root":"Checkbox1720959521__root"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    14,
    "Checkbox1720959521",
    null
);
